import qs from "qs";

import { isSsr } from "scmp-app/lib/utils";

import type { NewsletterPayload } from "./types";

export const shouldShowNewsletterSignUp = () => {
  if (isSsr()) return false;
  const parsedQueryString = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  }) as unknown as NewsletterPayload;
  return parsedQueryString.subscription === "true" && parsedQueryString.newsletterIds?.length > 0;
};
